import { useState, useContext, useEffect } from "react";
import { Grid, Paper, Typography, Button, Box } from '@mui/material'
import ChangePasswordPopup from "../auth/changePasswordPopup";
import DirectDebitPopup from "./directDebitPopup";
import { AuthContext } from '../../contexts/auth/authContext'
import { DataContext } from '../../contexts/data/dataContext'
import custom from '../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain } from '../../services/constants'
import { sendViewAnalytics } from '../common/util/util'

export default function AccountDetails() {
    const border = custom.border;
    const auth = useContext(AuthContext)
    const data = useContext(DataContext)
    const [changePassword, setChangePassword] = useState(false);
    const [directDebit, setDirectDebit] = useState(false);

    const resetPassword = () => {
        setChangePassword(true)
        sendViewAnalytics('/profile', {
              domain: analyticsDomain.profile,
              name: analyticsPage.changePassword
            })
    }

    const directDebitClicked = ()=>{
      setDirectDebit(true)
      sendViewAnalytics('/profile', {
            domain: analyticsDomain.profile,
            name: analyticsPage.directDebitForm
          })
    }

    useEffect(()=>{
      sendViewAnalytics('/profile', {
              domain: analyticsDomain.profile,
              name: analyticsPage.customerProfile
            })
    },[])

    return (
        <Box 
            px={custom.spacing.md}
            pt={{
                xs: custom.spacing.xxl,
                sm: data?.rightPanel?custom.spacing.md:0,
                md: 0,
                lg: 0
            }}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            >
            <Paper elevation={0} id={'AccountDetails'} 
                sx={{ 
                  borderRadius: custom.corners4, 
                  border,
                  width: '100%', 
                  boxSizing: 'border-box',
                }} >
                <Grid container direction="row" 
                        justifyContent="flex-start" 
                        width="100%"
                        pl={custom.spacing.md}
                        pr={custom.spacing.sm}
                        >
                        <Grid item xs={12} 
                            pt={custom.spacing.md}
                            pb={custom.spacing.xs}>
                            <Typography component={"h1"} 
                                variant="szHeading.Bold.Large">
                                Your account
                            </Typography>
                        </Grid>
                        <Grid item xs={12} 
                                py={custom.spacing.xs}>
                            <Typography variant="szBody.Regular.Small">
                                Name
                            </Typography>
                            <Typography component="p" 
                                id="customerName"
                                color="text.secondary" 
                                variant="szBody.Regular.Small">
                                    {data?.customer?.name}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} 
                            py={custom.spacing.xs}>
                            <Typography variant="szBody.Regular.Small">
                                Property Address
                            </Typography>
                            <Typography component="p" 
                                id="customerAddress"
                                color="text.secondary" 
                                variant="szBody.Regular.Small">
                                    {data?.customer?.address}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} 
                            py={custom.spacing.xs}>
                            <Typography variant="szBody.Regular.Small">
                                Contact phone number
                            </Typography>
                            <Typography component="p" 
                                id="customerPhone"
                                color="text.secondary" 
                                variant="szBody.Regular.Small">
                                    {data?.customer?.phone}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} 
                            py={custom.spacing.xs}>
                            <Typography variant="szBody.Regular.Small">
                                Email
                            </Typography>
                            <Typography component="p" 
                                id="customerEmail"
                                color="text.secondary" 
                                variant="szBody.Regular.Small">
                                    {data?.customer?.email}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} 
                            pt={custom.spacing.xs}
                            pb={custom.spacing.md}>
                            <Button variant='outlined' 
                                id="changePasswordButton"
                                sx={{
                                  px:custom.spacing.sm,
                                  py:custom.spacing.xs
                                }}
                                onClick={resetPassword}>
                                <Typography 
                                    color="primary"
                                    variant="szBody.Medium.Small">
                                        Change password
                                </Typography>
                            </Button>
                        </Grid>
                </Grid>
            </Paper>
            <Paper elevation={0} 
                sx={{ 
                  borderRadius: custom.corners4, 
                  border, 
                  width: '100%', 
                  boxSizing: 'border-box', 
                  mt: custom.spacing.sm
                }}>
              <Grid container 
                    direction="column" 
                    justifyContent="flex-start" 
                    alignItems="flex-start" 
                    display="flex"
                    pl={custom.spacing.md}
                    pr={custom.spacing.sm}
                    >
                <Grid item xs={12}
                      pt={custom.spacing.md}
                      pb={custom.spacing.xs}>
                  <Typography component={'h2'} 
                    variant="szHeading.Bold.Large">
                    Direct debit
                  </Typography>
                </Grid>
                {!data?.customer?.bankDirectDebit ? (
                  <>
                    <Grid item xs={12} 
                          py={custom.spacing.sm}>
                      <Typography component="p" 
                        variant="szBody.Regular.Small">
                        Set up your paperless direct debit to simplify your payments and enjoy an easy way to pay.
                      </Typography>
                    </Grid>
                    <Grid item xs={12} 
                          pt={custom.spacing.xs}
                          pb={custom.spacing.md}>
                      <Button variant="outlined" 
                        id="directDebitButton"
                        // disabled={!!auth?.staff}
                        onClick={() => directDebitClicked()}
                        sx={{
                          px:custom.spacing.sm,
                          py:custom.spacing.xs,
                          "&.Mui-disabled": {
                            backgroundColor: 'sz.colors.background',
                            color: "text.primary",
                            opacity: 0.6
                          }
                        }}>
                        <Typography color="primary" 
                          variant="szBody.Medium.Small">
                          Add bank account
                        </Typography>
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12} 
                          py={custom.spacing.xs}>
                      <Typography variant="szBody.Regular.Small">
                          Account Name
                      </Typography>
                      <Typography component="p"
                        id="bankAccountName"  
                        color="text.secondary" 
                        variant="szBody.Regular.Small">
                        {data?.customer?.bankDirectDebit?.accountName}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} 
                          py={custom.spacing.xs}>
                      <Typography variant="szBody.Regular.Small">
                          Account Number
                      </Typography>
                      <Typography component="p"
                        id="bankAccountNumber" 
                        color="text.secondary" 
                        variant="szBody.Regular.Small">
                        {data?.customer?.bankDirectDebit?.accountNumber}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} 
                          py={custom.spacing.xs}>
                      <Typography 
                        variant="szBody.Regular.Small">
                          Bank
                      </Typography>
                      <Typography component="p" 
                        id="bankName" 
                        color="text.secondary" 
                        variant="szBody.Regular.Small">
                        {data?.customer?.bankDirectDebit?.bank?.fullName}
                        {/* <Typography 
                          color="text.secondary" 
                          variant="szBody.Regular.xSmall">
                          <br/>{data?.customer?.bankDirectDebit?.bank?.city}
                        </Typography> */}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} 
                          pt={custom.spacing.xs}
                          pb={custom.spacing.md}>
                      <Button variant="outlined" 
                        id="directDebitButton"
                        // disabled={!!auth?.staff}
                        sx={{
                          px:custom.spacing.sm,
                          py:custom.spacing.xs,
                          "&.Mui-disabled": {
                            backgroundColor: 'sz.colors.background',
                            color: "text.primary",
                            opacity: 0.6
                          }
                        }}
                        onClick={() => directDebitClicked()}>
                        <Typography color="primary" 
                          variant="szBody.Medium.Small">
                          Update bank account
                        </Typography>
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </Paper>

            {/* Modal Popup */}
            <ChangePasswordPopup open={changePassword} 
                setOpen={setChangePassword} 
                newForm={true}/>
            <DirectDebitPopup open={directDebit} 
                setOpen={setDirectDebit} />
        </Box>
    )
}